import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class AemExtra2 extends TrackableEntity {
    pcs: number = 0;
    gWeight: number = 0;
    strGWeight: string = '';
    kgLb: string = '';
    r: string = '';
    item: string = '';
    cWeight: number = 0;
    strCWeight: string = '';
    rate: number = 0;
    strRate: string = '';
    tbId: number = 0;
    total: number = 0;
    strTotal: string = '';
    id: number = 0;

    constructor(init?:Partial<AemExtra2>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('strGWeight', 'strCWeight', 'strRate', 'strTotal', 'id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return AemExtra2.dicFieldMapping;
    }

    static dicFieldMapping:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'pcs': new DBMappingInfo({ field: 'F_N2', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'gWeight': new DBMappingInfo({ field: 'F_F1', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'kgLb': new DBMappingInfo({ field: 'F_C1', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'r': new DBMappingInfo({ field: 'F_C2', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'item': new DBMappingInfo({ field: 'F_C3', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'cWeight': new DBMappingInfo({ field: 'F_F2', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'rate': new DBMappingInfo({ field: 'F_F3', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),
        'total': new DBMappingInfo({ field: 'F_F4', table: 't_aotherinfo', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 10 }),

    };
}
